import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const Error = () => {
  return (
    <Container>
      <Row>
        <Col>
          <h1>Error 404 - Página no encontrada</h1>
        </Col>
      </Row>
    </Container>
        
  )
}

export default Error